<div class="main-grid py-4 px-1 page-height overflow-auto">
  <app-trades-viewer
    class="trades-container trades-card flex justify-center items-center m-auto"
    style="display: inline-block"
  ></app-trades-viewer>
  @if (userDetails$ | async; as userData) {
  <div class="tools-container px-6">
    <div class="flex flex-row justify-start items-center gap-4">
      <mat-form-field
        appearance="outline"
        class="mt-4"
        style="text-align: center !important"
      >
        <mat-label>Search</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Ex. Corn"
          #input
        />
      </mat-form-field>
      @if (userData.market_options.length) {
      <span>
        @if (userData.market_options.length > 1) {
        <mat-form-field class="mt-4" appearance="outline">
          <mat-label>Select Market</mat-label>
          <mat-select
            [value]="selectedMarket"
            (selectionChange)="getLots($event.value)"
          >
            @for (option of userData.market_options; track option; let i =
            $index) {
            <mat-option [value]="option">
              @switch(option){ @case ('Farm'){ FOB Farm }@case('Feed'){DOMESTIC}
              @default {
              {{ option | uppercase }}} }
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
      </span>
      }
      <div
        *appBlockUserRoles="['viewer']"
        class="flex flex-row justify-start items-center gap-4"
      >
        @if (userData.role !== userRoles.Farmer && userData.role !==
        userRoles.Viewer) {
        <button
          class="text-sm self-center bid-btn"
          (click)="navigateToNew('bid')"
          mat-raised-button
          color="primary"
        >
          <mat-icon fontIcon="add" />New Bid
        </button>
        }
        <button
          class="offer-btn text-sm"
          (click)="navigateToNew('offer')"
          mat-raised-button
        >
          <mat-icon fontIcon="add" />New Offer
        </button>
      </div>
    </div>
  </div>
  <div class="table-container px-6">
    <div class="table-container">
      <table mat-table matSort [dataSource]="dataSource">
        <ng-container matColumnDef="lot_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Bid/Offer</th>
          <td mat-cell *matCellDef="let lot" style="width: fit-content">
            <div class="flex flex-row items-center justify-start text-left">
              <mat-chip-set>
                @if (userData._id == lot.user_id) {
                <mat-chip
                  aria-label="sent-counter"
                  disableRipple="true"
                  class="text-xs purple-chip p-0"
                  >My
                </mat-chip>
                } @if(!lot.broker_indication ){
                <mat-chip
                  style="margin-left: 4px !important"
                  class="text-xs"
                  disableRipple="true"
                  [ngClass]="{
                    'blue-chip': lot.lot_type === 'Offer',
                    'green-chip': lot.lot_type === 'Bid'
                  }"
                >
                  {{ lot.lot_type | titlecase }}
                </mat-chip>
                } @if (lot.indication && !lot.broker_indication) {
                <mat-chip
                  disableRipple="true"
                  class="text-xs light-blue-chip p-0"
                  matTooltip="Bid/Offer indication represents a non-binding expression of interest from a buyer (bid) or seller (offer) to transact at a specific price or within a price range."
                  aria-label="Button that displays a tooltip when focused or hovered over"
                  >Indication
                </mat-chip>
                }
                <app-jc-trading-indication
                  [showIndication]="lot.broker_indication"
                ></app-jc-trading-indication>
                @if(lot.hasNegotiations){
                <fa-icon
                  [icon]="faHandShake"
                  size="lg"
                  [style]="{ color: '#ff9500', padding: '5px' }"
                ></fa-icon>
                }
              </mat-chip-set>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="commodity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Crop</th>
          <td
            mat-cell
            class="text-xs"
            *matCellDef="let lot"
            class="fasdlex flex-casdol justify-center items-center"
          >
            {{ lot.commodity }}
            @if (lot.product_type !== '-' && lot.product_type !== null) {
            <span> - {{ lot.product_type }}</span>
            } @if (lot.grade !== '-' && lot.grade !== null) { - {{ lot.grade }}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="price">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            matSortActive="amount"
          >
            Price
          </th>
          <td mat-cell *matCellDef="let lot">
            <!-- TODO : fix sorting. Currently this doesn't sort when clicked header column bc matColumnDef is different than data source price name   -->
            @if(lot.indication){~}
            {{ lot.currency }} ${{ lot.price | priceType }} /
            {{ lot.price_units }}
          </td>
        </ng-container>
        <ng-container matColumnDef="volume_value">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Volume</th>
          <td mat-cell *matCellDef="let lot">
            {{ lot.volume_value }} {{ lot.units }}
          </td>
        </ng-container>
        <ng-container matColumnDef="delivery_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Delivery</th>
          <td mat-cell *matCellDef="let lot">
            {{ lot.delivery_type }} - {{ lot.destination | domesticCity }}
          </td>
        </ng-container>
        <ng-container matColumnDef="ship_begin">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Shipping</th>
          <td mat-cell *matCellDef="let lot" class="text-xs">
            <!-- {{lot.ship_begin | date: 'MMM d, y'}} - {{lot.ship_end | date: 'MMM d, y'}} <br> -->
            {{
              (lot.ship_begin | date : "MMM d, y" : "UTC") +
                " - " +
                (lot.ship_end | date : "MMM d, y" : "UTC") | sameYear
            }}
            <br />
          </td>
        </ng-container>
        <tr
          id="title-cols"
          style="width: fit-content !important"
          mat-header-row
          *matHeaderRowDef="displayColumns"
          sticky
        ></tr>
        <tr
          mat-row
          id="data-rows"
          *matRowDef="let lot; columns: displayColumns"
          [class.offer-text]="lot.lot_type === 'Offer'"
          [class.bid-text]="lot.lot_type === 'Bid'"
          [class.selected-lot]="lot._id === activeLotId()"
          [ngClass]="{
            'selected-bid': lot._id === activeLotId() && lot.lot_type === 'Bid',
            'selected-offer':
              lot._id === activeLotId() && lot.lot_type === 'Offer'
          }"
          (click)="clickRow(lot)"
        ></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="6" class="mx-4 px-4">No data</td>
        </tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[10, 20, 30, 40]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
  }

  <div class="details-container flex flex-row gap-3 justify-start items-start">
    <app-lot-details-card
      *appBlockUserRoles="['viewer']"
      (counterClicked)="scrollToCounter()"
      class="lot-details-card"
    ></app-lot-details-card>
  </div>

  <div
    class="negotiations-container flex flex-row gap-3 justify-start items-start"
  >
    <app-negotiation-details-card
      #counter
      *appBlockUserRoles="['viewer']"
      class="negotiations-details-card"
    ></app-negotiation-details-card>
  </div>
</div>
